<div>
  <div
    nz-col
    id="dataview-filter"
    class="filter-holder"
    style="width: 123px"
    [ngStyle]="{ width: isNavRevisionFilter ? '150px' : '123px' }"
  >
    <label class="filter-label">Data/Revisions</label>
    <button
      nz-button
      nz-popover
      [nzPopoverBackdrop]="true"
      nzPopoverTrigger="click"
      [nzPopoverContent]="
        isNavRevisionFilter ? navRevisionFilterTemplate : contentTemplate
      "
      nzPopoverPlacement="bottomLeft"
      [(nzPopoverVisible)]="dataViewFilterVisible"
      (nzPopoverVisible)="popoverChange()"
      class="filter-btn"
      style="width: 100%"
    >
      <span [innerHTML]="selectedDataView"></span>
      <span></span>
      <i nz-icon [nzType]="popoverOpen ? 'up' : 'down'" class="arrow"></i>
    </button>

    <ng-template #contentTemplate>
      <ul nz-menu class="list-style revision-option-list">
        <li nz-menu-item *ngIf="singleSelect">
          <nz-radio-group
            [(ngModel)]="viewBy"
            nzName="viewByOption"
            (ngModelChange)="chkboxOptChange()"
            *ngFor="let option of checkOptions"
          >
            <label nz-radio [nzValue]="option.value" class="radio-opt">
              {{ option.label }}
            </label>
          </nz-radio-group>
        </li>
        <li nz-menu-item *ngIf="!singleSelect">
          <nz-checkbox-group
            [(ngModel)]="checkOptions"
            (ngModelChange)="chkboxOptChange()"
          ></nz-checkbox-group>
        </li>
        <li nz-menu-divider></li>
        <li nz-menu-item style="height: 90px">
          <nz-radio-group
            [(ngModel)]="radioValue"
            class="radio"
            (ngModelChange)="radioValChange()"
          >
            <label nz-radio nzValue="1m" class="radio-opt"
              >&Delta; 1 month</label
            >
            <label nz-radio nzValue="3m" class="radio-opt"
              >&Delta; 3 months</label
            >
            <label nz-radio nzValue="custom" class="radio-opt"
              ><span class="date-picker"
                >&Delta;
                <nz-date-picker
                  [(ngModel)]="customDate"
                  [nzDisabledDate]="disabledCustomDate"
                  (ngModelChange)="onDateChange()"
                  nzPlaceHolder="Custom Days"
                  [ngStyle]="{
                    'border-bottom': inValidCustomDate
                      ? '1px solid red'
                      : '1px solid #979797'
                  }"
                ></nz-date-picker></span
              ><i
                nz-icon
                nzType="exclamation-circle"
                nzTheme="outline"
                style="color: red"
                *ngIf="inValidCustomDate"
              ></i
            ></label>
          </nz-radio-group>
        </li>
        <li nz-menu-divider></li>
        <li class="buttons">
          <div
            class="err-msg-holder"
            *ngIf="invalidDataview"
            style="width: 110px; line-height: 1"
          >
            <i
              nz-icon
              nzType="exclamation-circle"
              nzTheme="outline"
              style="color: red"
            ></i>
            <span class="err-msg">{{ dvErrMsg }}</span>
          </div>
          <div class="button-container">
            <button
              nz-button
              class="btn"
              (click)="onResetDataView()"
              *ngIf="showReset"
            >
              Reset
            </button>
            <button nz-button nzType="primary" (click)="applyDataView()">
              Apply
            </button>
          </div>
        </li>
      </ul>
    </ng-template>
    <ng-template #navRevisionFilterTemplate>
      <ul nz-menu class="list-style revision-option-list">
        <li nz-menu-item>
          <nz-radio-group
            [(ngModel)]="viewBy"
            nzName="viewByOption"
            (ngModelChange)="chkboxOptChange()"
            *ngFor="let option of checkOptions"
          >
            <label nz-radio [nzValue]="option.value" class="radio-opt">
              {{ option.label }}
            </label>
          </nz-radio-group>
        </li>
      </ul>
      <li nz-menu-divider></li>
      <ul nz-menu class="list-style revision-option-list">
        <li nz-menu-item style="height: 120px">
          <nz-radio-group [(ngModel)]="radioValue" class="radio">
            <label
              nz-radio
              nzValue="today"
              class="radio-opt"
              [nzDisabled]="viewBy === 'revision'"
            >
              Today</label
            >
            <label nz-radio nzValue="1m" class="radio-opt"> 1 month</label>
            <label nz-radio nzValue="3m" class="radio-opt"> 3 months</label>
            <label nz-radio nzValue="custom" class="radio-opt"
              ><span class="date-picker">
                <nz-date-picker
                  [(ngModel)]="customDate"
                  [nzDisabledDate]="disabledCustomDate"
                  (ngModelChange)="onDateChange()"
                  nzPlaceHolder="Custom Days"
                  [ngStyle]="{
                    'border-bottom': inValidCustomDate
                      ? '1px solid red'
                      : '1px solid #979797'
                  }"
                ></nz-date-picker></span
              ><i
                nz-icon
                nzType="exclamation-circle"
                nzTheme="outline"
                style="color: red"
                *ngIf="inValidCustomDate"
              ></i
            ></label>
          </nz-radio-group>
        </li>
        <li nz-menu-divider></li>
        <li class="buttons">
          <div
            class="err-msg-holder"
            *ngIf="invalidDataview"
            style="width: 110px; line-height: 1"
          >
            <i
              nz-icon
              nzType="exclamation-circle"
              nzTheme="outline"
              style="color: red"
            ></i>
            <span class="err-msg">{{ dvErrMsg }}</span>
          </div>
          <div class="button-container">
            <button
              nz-button
              class="btn"
              (click)="onResetDataViewForNav()"
              *ngIf="showReset"
            >
              Reset
            </button>
            <button nz-button nzType="primary" (click)="applyNavDataView()">
              Apply
            </button>
          </div>
        </li>
      </ul>
    </ng-template>
  </div>
</div>
